import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationActivateGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthenticationService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isResponseRequired && state.url !== '/manage') {
      this.router.navigate(['/manage']);
      return false;
    }
    if (this.authService.isAuthenticated &&
      (this.authService.hasPermission(next.data.permissions) || this.authService.inRoles(next.data.roles))) {
      return true;
    } else {
      this.authService.logout(state.url);
    }
    return false;
  }
}
